export default "__VITE_ASSET__B8ihDlLr__"